import React from 'react';
import { Calendar } from 'primereact/calendar';

const ProfileAcademicTitleForm = ({ isOpen, onClose, onSubmit, formData, setFormData, units = [], degrees = [], titles = [], isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="modal-header">
                    <h3>{isEditing ? "Cập nhật Học vị - Chức danh" : "Thêm mới Học vị - Chức danh"}</h3>

                    <button
                        type="button"
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '24px', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="academicTitleForm" onSubmit={onSubmit}>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Đơn vị công tác *</label>
                            <select name="UnitName" className="form-input" value={formData.UnitName || ''} onChange={handleChange} required>
                                <option value="">Chọn đơn vị</option>
                                {units.map((u) => <option key={u.Id} value={u.Name}>{u.Name}</option>)}
                            </select>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Học vị *</label>
                                <select name="DegreeName" className="form-input" value={formData.DegreeName || ''} onChange={handleChange} required>
                                    <option value="">Chọn học vị</option>
                                    {degrees.map((d) => <option key={d.Id} value={d.Name}>{d.Name}</option>)}
                                </select>
                            </div>

                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày nhận bằng *</label>
                                <Calendar
                                    id="DegreeDate"
                                    name="DegreeDate"
                                    value={(formData.DegreeDate && !isNaN(new Date(formData.DegreeDate).getTime())) ? new Date(formData.DegreeDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('DegreeDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Học hàm</label>
                            <select name="AcademicRank" className="form-input" value={formData.AcademicRank || ''} onChange={handleChange}>
                                <option value="">Chọn học hàm (nếu có)</option>
                                <option value="Giáo sư">Giáo sư</option>
                                <option value="Phó giáo sư">Phó giáo sư</option>
                            </select>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Chức danh nghề nghiệp</label>
                                <select name="TitleName" className="form-input" value={formData.TitleName || ''} onChange={handleChange}>
                                    <option value="">Chọn chức danh</option>
                                    {titles
                                        .filter((t) => t.Name !== 'Giáo sư' && t.Name !== 'Phó giáo sư')
                                        .map((t) => <option key={t.Id} value={t.Name}>{t.Name}</option>)
                                    }
                                </select>
                            </div>

                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày nhận bổ nhiệm</label>
                                <Calendar
                                    id="TitleDate"
                                    name="TitleDate"
                                    value={(formData.TitleDate && !isNaN(new Date(formData.TitleDate).getTime())) ? new Date(formData.TitleDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('TitleDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                            <input type="checkbox" name="IsCurrent" id="isCurrent" checked={formData.IsCurrent || false} onChange={handleChange} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                            <label htmlFor="isCurrent" style={{ margin: 0, fontWeight: 'normal', cursor: 'pointer' }}>Hiện tại áp dụng</label>
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="academicTitleForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileAcademicTitleForm;